import { OptionTitle } from "./OptionTitle"

const MetabolicDoAnyApplyOptions: Array<OptionTitle> = [
  { title: "Overweight", id: "OVERWEIGHT" },
  { title: "Obesity", id: "OBESITY" },
  { title: "Diabetes, pre-diabetes, or insulin resistance", id: "DIABETES" },
  { title: "Metabolic syndrome", id: "METABOLIC_SYNDROME" },
  { title: "High cholesterol or dyslipidemia", id: "HIGH_CHOLESTEROL" },
  { title: "Polycystic ovary syndrome (PCOS)", id: "PCOS" },
  { title: "Fatty liver disease", id: "FATTY_LIVER_DISEASE" },
  { title: "Lipodystrophy", id: "LIPODYSTROPHY" }
]

const PregnancyDoAnyApplyOptions: Array<OptionTitle> = [
  { title: "Recurrent pregnancy loss", id: "RECURRENT_PREGNANCY_LOSS" },
  { title: "Preeclampsia or high blood pressure", id: "PREECLAMPSIA_HIGH_BLOOD_PRESSURE" },
  { title: "Gestational diabetes", id: "GESTATIONAL_DIABETES" },
  {
    title: "Metabolic conditions (e.g., diabetes, polycystic ovary syndrome, overweight, obesity)",
    id: "METABOLIC_CONDITIONS"
  },
  { title: "Preterm labor or delivery", id: "PRETERM_LABOR_DELIVERY" },
  { title: "A cesarean birth", id: "CESAREAN_BIRTH" },
  { title: "Placenta previa, accreta, or abruption", id: "PLACENTA_PREVIA_ACCRETA_ABRUPTION" },
  {
    title:
      "Other medical condition impacting pregnancy (e.g., fertility diagnosis, thyroid disorder, endometriosis, history of blood clotting disorders)",
    id: "OTHER_CONDITION"
  },
  { title: "Over the age of 35", id: "OVER_35" }
]

export const DoAnyApplyOptions: Array<OptionTitle> = [
  ...MetabolicDoAnyApplyOptions,
  ...PregnancyDoAnyApplyOptions,
  { title: "Over the age of 40", id: "OVER_40" },
  { title: "Two or more unintended pregnancy losses", id: "TWO_LOSSES" },
  { title: "Urgent medical need for fertility preservation", id: "URGENT_MEDICAL_NEED" },
  { title: "Never menstruated", id: "NEVER_MENSTRUATED" },
  { title: "Immediate family member with history of blood clotting disorders", id: "FAMILY_BLOOD_CLOTTING" },
  { title: "None of the above", id: "NONE" }
]
